var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h1',[_vm._v("404")]),_c('h2',[_vm._v("Not Found!")]),_c('p',[_c('a',{staticClass:"link-return",attrs:{"href":"/"}},[_vm._v("Ir al inicio")])])])
}]

export { render, staticRenderFns }